import { RouteLocationRaw } from 'vue-router';

export function buildLpUrl(path?: string): string {
  const baseUrl: string = appSettings.VUE_APP_URL_SITE_INSTITUCIONAL
    .replace(/\/$/, ''); // remove trailing slash

  if (!path) return baseUrl;

  if (/^[?#]/.test(path)) return `${baseUrl}${path}`;

  const [basePath, ...queryAndHash] = path.split(/(?=[?#])/);
  const sanitizedPath = basePath
    .replace(/\/+/g, '/') // remove double slashes
    .replace(/(^\/|\/$)/g, ''); // remove leading/trailing slashes

  return !sanitizedPath ? baseUrl : `${baseUrl}/${sanitizedPath}${queryAndHash.join('')}`;
}

interface Solicitar2faParams {
  api: string,
  returnUrl: string
}

export function build2faUrl(opts: Solicitar2faParams): RouteLocationRaw {
  const { api, returnUrl } = opts;
  return {
    path: `/divida/${api}/autenticacao`,
    query: { returnTo: returnUrl },
  };
}
